import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RadioButtonComponent } from './radio-button/radio-button.component';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { ThankYouMessageComponent } from './thank-you-message/thank-you-message.component';
import { TooltipDirective } from '../_directives/tooltip.directive';
import { ImageControlComponent } from './image-control/image-control.component';
import { ProgressbarComponent } from './progressbar/progressbar.component';
import { TextBoxComponent } from './text-box/text-box.component';
import { QDLTextBoxComponent } from './qdltext-box/qdltext-box.component';
import { AnonymousComponent } from './anonymous/anonymous.component';
import { DescriptiveTextComponent } from './descriptive-text/descriptive-text.component';
import { CheckBoxComponent } from './check-box/check-box.component';
import { QuestionTitleComponent } from './question-title/question-title.component';
import { RankingComponent } from './ranking/ranking.component';
import { DropDownComponent } from './drop-down/drop-down.component';
import { RatingScaleComponent } from './rating-scale/rating-scale.component';
import { FormsModule } from '@angular/forms';
import { NumericAllocationComponent } from './numeric-allocation/numeric-allocation.component';
import { DragDropModule } from '@angular/cdk/drag-drop';

import { DemographicsComponent } from './demographics/demographics.component';
import { MultipleTextBoxComponent } from './multiple-text-box/multiple-text-box.component';
import { MultipleDropDownComponent } from './multiple-drop-down/multiple-drop-down.component';
import { SymbolRatingScaleComponent } from './symbol-rating-scale/symbol-rating-scale.component';
import { SurveyMessagesComponent } from './survey-messages/survey-messages.component';
import { AnswerImagesComponent } from './answer-images/answer-images.component';
import { DrillDownComponent } from './drill-down/drill-down.component';
import { MatrixGridComponent } from './matrix-grid/matrix-grid.component';
import { GridQuestionsComponent } from './grid-questions/grid-questions.component';
import { AnswerMediaComponent } from './answer-media/answer-media.component';
import { MediaControlComponent } from './media-control/media-control.component';
import { SignUpComponent } from './sign-up/sign-up.component';
import { QuestionSpacerComponent } from './question-spacer/question-spacer.component';
import { CallBackPipe } from '../_pipe/call-back.pipe';
import { GDPRComponent } from './gdpr/gdpr.component';
import { QuestionImageAndMediaComponent } from './question-image-and-media/question-image-and-media.component';
import { ThumbsUpComponent } from './thumbs-up/thumbs-up.component';
import { TelephoneComponent } from './telephone/telephone.component';
import { MediaPlayerComponent } from './media-player/media-player.component';
import { OfflineComponent } from './offline/offline.component';
import { AudioPlayerComponent } from './audio-player/audio-player.component';
import { PipeModule } from '../_pipe/pipe.module';
import { HighchartsChartModule } from 'highcharts-angular';
import { AngularSignaturePadModule } from '@almothafar/angular-signature-pad';
import { NgxCaptchaModule } from 'ngx-captcha';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeng/themes/aura';
import { DatePicker } from 'primeng/datepicker';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

@NgModule({
  declarations: [
    RadioButtonComponent,
    HeaderComponent,
    FooterComponent,
    ThankYouMessageComponent,
    CallBackPipe,
    TooltipDirective,
    ImageControlComponent,
    ProgressbarComponent,
    TextBoxComponent,
    QDLTextBoxComponent,
    AnonymousComponent,
    DescriptiveTextComponent,
    CheckBoxComponent,
    QuestionTitleComponent,
    RankingComponent,
    DropDownComponent,
    RatingScaleComponent,
    NumericAllocationComponent,
    DemographicsComponent,
    MultipleTextBoxComponent,
    MultipleDropDownComponent,
    SymbolRatingScaleComponent,
    SurveyMessagesComponent,
    AnswerImagesComponent,
    DrillDownComponent,
    MatrixGridComponent,
    GridQuestionsComponent,
    AnswerMediaComponent,
    MediaControlComponent,
    SignUpComponent,
    // Question Space
    QuestionSpacerComponent,
    GDPRComponent,
    QuestionImageAndMediaComponent,
    ThumbsUpComponent,
    TelephoneComponent,
    MediaPlayerComponent,
    OfflineComponent,
    AudioPlayerComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    NgxCaptchaModule,
    PipeModule,
    AngularSignaturePadModule,
    HighchartsChartModule,
    DragDropModule,
    DatePicker,
    BrowserAnimationsModule
  ],
  exports: [
    RadioButtonComponent,
    HeaderComponent,
    FooterComponent,
    ThankYouMessageComponent,
    CallBackPipe,
    TooltipDirective,
    ProgressbarComponent,
    TextBoxComponent,
    QDLTextBoxComponent,
    AnonymousComponent,
    DescriptiveTextComponent,
    CheckBoxComponent,
    RankingComponent,
    DropDownComponent,
    RatingScaleComponent,
    ImageControlComponent,
    NumericAllocationComponent,
    NgxCaptchaModule,
    DemographicsComponent,
    MultipleTextBoxComponent,
    MultipleDropDownComponent,
    SymbolRatingScaleComponent,
    SurveyMessagesComponent,
    DrillDownComponent,
    MatrixGridComponent,
    GridQuestionsComponent,
    SignUpComponent,
    // Question Space
    QuestionSpacerComponent,
    GDPRComponent,
    ThumbsUpComponent,
    OfflineComponent,
  ],
  providers: [
    providePrimeNG({
      theme: {
          preset: Aura
      }
  })
  ]
})
export class ControlsModule { }
